//DESKTOP | LAPTOP | TABLET
import React from "react";
import { useTheme } from "../../providers/theme-provider";
import useWindowSize from "../../hooks/use-window-size";
import { useTranslation } from "react-i18next";
import spacings from "../../theme/spacings";
import { assetIcons } from "../../constants/assets";
import { fontSizes } from "../../theme/font-sizes";
import { Link } from "react-router-dom";
import { socialRedirectUrls, urls } from "../../constants/urls";

const Footer = () => {
  const { colors } = useTheme();
  const { width } = useWindowSize();
  const isMobile = width < 1024;

  const { t } = useTranslation();

  const paddingLeftRight = isMobile
    ? spacings.leftRightSpacingMobile
    : spacings.leftRightSpacing;

  const paddingTopBottom = isMobile
    ? spacings.topBottomSpacingMobile
    : spacings.topBottomSpacing;
  return (
    <div
      style={{
        backgroundColor: colors.primary,
      }}
      className="relative z-10"
    >
      <div
        style={{
          paddingLeft: paddingLeftRight,
          paddingRight: paddingLeftRight,
          paddingTop: paddingTopBottom + 60,
          paddingBottom: paddingTopBottom,
        }}
        className="max-w-[1400px] mx-auto"
      >
        <div className=" flex justify-between items-start flex-wrap gap-10">
          <div className="flex flex-col gap-6">
            <img src={assetIcons.logoFooter} alt="" className="w-32" />

            <p
              style={{
                color: colors.background,
                fontSize: fontSizes.body,
              }}
              className="max-w-[260px]"
            >
              {t("footerText")}
            </p>

            <div className="flex  gap-3">
              <Link
                className="py-2 px-2 flex justify-center items-center rounded-sm w-10 h-10 cursor-pointer "
                style={{
                  backgroundColor: colors.socialBg,
                }}
                to={socialRedirectUrls.facebook}
              >
                <img src={assetIcons.facebook} alt="" className="" />
              </Link>
              <Link
                className=" py-2 px-2 flex justify-center items-center rounded-sm w-10 h-10 cursor-pointer"
                style={{
                  backgroundColor: colors.socialBg,
                }}
                to={socialRedirectUrls.twitter}
              >
                <img src={assetIcons.twitter} alt="" className="" />
              </Link>
              <Link
                className=" py-2 px-2 flex justify-center items-center rounded-sm w-10 h-10 cursor-pointer"
                style={{
                  backgroundColor: colors.socialBg,
                }}
                to={socialRedirectUrls.instagram}
              >
                <img src={assetIcons.instagram} alt="" className="" />
              </Link>
              <Link
                className=" py-2 px-2 flex justify-center items-center rounded-sm w-10 h-10 cursor-pointer"
                style={{
                  backgroundColor: colors.socialBg,
                }}
                to={socialRedirectUrls.linkedIn}
              >
                <img src={assetIcons.linkedin} alt="" className="" />
              </Link>
            </div>
          </div>

          <div className="flex sm:gap-16 gap-8">
            <div className="flex flex-col gap-4">
              <h3 style={{}} className="text-gray-100 text-xl font-semibold">
                {t("footerHeading1")}
              </h3>
              <ul className="flex flex-col gap-3">
                <Link to={urls.dijinx}>
                  <li className="text-gray-50">{t("heading1Text1")}</li>
                </Link>
                <Link to={urls.dijinx}>
                  <li className="text-gray-50">{t("heading1Text2")}</li>
                </Link>
                <Link to={urls.dijinx}>
                  <li className="text-gray-50">{t("heading1Text3")}</li>
                </Link>
                <Link to={urls.dijinx}>
                  <li className="text-gray-50">{t("heading1Text4")}</li>
                </Link>
              </ul>
            </div>
            <div className="flex flex-col gap-4">
              <h3 style={{}} className="text-gray-100 text-xl font-semibold">
                {t("footerHeading2")}
              </h3>
              <ul className="flex flex-col gap-3">
                <Link to={urls.dijinx}>
                  <li className="text-gray-50">{t("heading2Text1")}</li>
                </Link>
                <Link to={urls.dijinx}>
                  <li className="text-gray-50 max-w-[180px]">
                    {t("heading2Text2")}
                  </li>
                </Link>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
